import { useMutation } from "react-query";
import getDisbursementSummary from "../services/getDisbursementSummary";

function useGetDisbursementSummary() {
  return useMutation(["disbursement-summary"], getDisbursementSummary);
}

export default useGetDisbursementSummary;
